module.exports = __webpack_public_path__ + "static/media/team-member-05.000a3d89.jpg";